/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */
import groupService from '@/services/group';
import store from '@/store';

export default {
  data() {
    return {
      groupDialogVisible: false,
      deleteDialog: false,
      editDialog: false,
      form: {
        _id: '',
        name: '',
        isDressOwner: false,
      },
      rules: {},
      selectedGroup: {},
      pageSize: 10,
      selectedPage: 1,
    };
  },
  computed: {
    groups() {
      return store.state.group.groups;
    },
    count() {
      return store.state.group.count;
    },
  },
  mounted() {
    this.fetchPage();
  },
  components: {
    VLayout: require('@/layouts/default/default.vue'),
    VPanel: require('@/components/panel/panel.vue'),
  },
  methods: {
    onSubmit(form) {
      this.groupDialogVisible = false;
      this.$refs.form.validate((valid) => {
        if (valid) {
          groupService.create($.extend({}, form));
          this.form.name = '';
        } else {
          return false;
        }
        return true;
      });
    },
    fetchPage() {
      store.dispatch('group/getGroup', {
        limit: this.pageSize,
        skip: (this.selectedPage - 1) * this.pageSize,
      });
    },
    confirmDelete(group) {
      this.selectedGroup = group;
      this.deleteDialog = true;
    },
    deleteSelectedGroup() {
      this.deleteDialog = false;
      groupService.del(this.selectedGroup);
    },
    showEditDialog(group) {
      this.form = $.extend({}, group);
      this.editDialog = true;
    },
    onSubmitEdit(form) {
      this.editDialog = false;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          groupService.edit($.extend({}, form));
          this.form = {};
          return true;
        }
        return false;
      });
    },
    handlePageChange(page) {
      this.selectedPage = page;
      this.fetchPage();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchPage();
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/customer/group/index.js